(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Inject featured product description and create bottom row wrapper
  document.addEventListener('DOMContentLoaded', () => {
    const featuredItem = document.querySelector('.product-grid__item--featured');
    if (!featuredItem) return;

    const productCard = featuredItem.querySelector('.product-card__content');
    if (!productCard) return;

    // El bottom row (.featured-product__bottom) solo es visible en
    // desktop (display:none en mobile). Si movemos el quick-view ahí en
    // mobile, queda oculto en la card destacada. Por eso solo se arma
    // el bottom row en desktop; en mobile el quick-view se queda en la
    // card (y la regla mobile lo deja fijo y visible como en las demás).
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (!isDesktop) return;

    // Create bottom row wrapper
    const bottomWrapper = document.createElement('div');
    bottomWrapper.className = 'featured-product__bottom';

    // Add description if available
    const description = featuredItem.getAttribute('data-featured-description');
    if (description) {
      const descriptionEl = document.createElement('p');
      descriptionEl.className = 'featured-product__description';
      descriptionEl.textContent = description;
      bottomWrapper.appendChild(descriptionEl);
    }

    // Move quick-view button to bottom wrapper
    const quickViewBtn = productCard.querySelector('.quick-view-button-wrapper');
    if (quickViewBtn) {
      bottomWrapper.appendChild(quickViewBtn);
    }

    // Append bottom wrapper to card
    if (bottomWrapper.children.length > 0) {
      productCard.appendChild(bottomWrapper);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
